import { Dispatch } from "redux";
import { fetchModulesError, fetchModulesPending, fetchModulesSuccess } from "../redux/actions/ModuleActions";
import SuiteApi from "./../api/SuiteApi";

export function fetchModules() {
  return (dispatch: Dispatch) => {
    dispatch(fetchModulesPending());
    SuiteApi.getModules()
      .then((modules) => {
        dispatch(fetchModulesSuccess(modules));
      })
      .catch((error) => {
        console.log("Error fetching module info", { error });
        dispatch(fetchModulesError(error));
      });
  };
}
